/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useCallback, useEffect, useState } from "react";
import { useShowError } from "~/components/Error/useShowError";
import { PDEscalationPolicy } from "~/models/pagerDuty";
import { useAxios } from "~/tools";

const usePDEscalationPolicies = () => {
  const [escalationPolicies, setEscalationPolicies] = useState<
    PDEscalationPolicy[]
  >([]);
  const [escalationPoliciesLoading, setEscalationPoliciesLoading] = useState(
    false
  );

  const { Axios } = useAxios();
  const { showError } = useShowError();

  const fetchEPs = useCallback(async () => {
    setEscalationPoliciesLoading(true);
    try {
      const { data } = await Axios().get("/mcrp/pagerduty/escalation-policies");
      setEscalationPolicies(data?.escalation_policies);
    } catch (e) {
      showError(e.response);
    }
    setEscalationPoliciesLoading(false);
  }, [setEscalationPoliciesLoading, Axios, setEscalationPolicies, showError]);

  useEffect(() => {
    fetchEPs();
  }, [fetchEPs]);

  return { escalationPolicies, escalationPoliciesLoading };
};

export { usePDEscalationPolicies };
